import { Card, theme, Typography } from "kosmos-ui/lib";

import { useLayout } from "app/context/LayoutContext/hooks";
import {
  AnalyticsIcon,
  EditIcon,
  ShoppingIcon,
  UsersIcon,
} from "app/assets/icons";

import {
  FeaturesSectionContainer,
  FeaturesCardsContainer,
  FeaturesIconContainer,
} from "./styles";

export default function FeaturesSection() {
  const { mobile } = useLayout();

  return (
    <FeaturesSectionContainer>
      <Typography
        as="h1"
        variant="title1"
        style={{
          color: theme.colorsPalette.white.default,
          textAlign: mobile ? "center" : "unset",
          maxWidth: 896,
          marginBottom: 0,
        }}
      >
        Todo lo que necesitas.
      </Typography>

      <Typography
        as="h1"
        variant="title1"
        style={{
          color: theme.colorsPalette.white.default,
          maxWidth: 896,
          textAlign: mobile ? "center" : "unset",
          marginBottom: 48,
        }}
      >
        En un solo lugar.
      </Typography>

      <FeaturesCardsContainer>
        <Card
          style={{
            padding: mobile ? "30px 28px" : "30px 50px",
            alignItems: mobile ? "center" : "unset",
            backgroundColor: "hsl(0deg 0% 3%)",
          }}
        >
          <FeaturesIconContainer>
            <UsersIcon height="56px" />
          </FeaturesIconContainer>

          <Typography
            as="h2"
            variant="title3"
            style={{
              color: theme.colorsPalette.white.default,
              textAlign: mobile ? "center" : "unset",
            }}
          >
            Networking y monitoreo de seguidores
          </Typography>

          <Typography
            as="p"
            variant="paragraph1"
            style={{ textAlign: mobile ? "center" : "unset" }}
          >
            Te conectamos con nuevos clientes interesados en tu marca. Conocerás
            sus comportamientos de compra y recibirás feeback constante para
            llegar a ellos.
          </Typography>
        </Card>

        <Card
          style={{
            padding: mobile ? "30px 28px" : "30px 50px",
            alignItems: mobile ? "center" : "unset",
            backgroundColor: "hsl(0deg 0% 3%)",
          }}
        >
          <FeaturesIconContainer>
            <ShoppingIcon height="56px" />
          </FeaturesIconContainer>

          <Typography
            as="h2"
            variant="title3"
            style={{
              color: theme.colorsPalette.white.default,
              textAlign: mobile ? "center" : "unset",
            }}
          >
            Tienda virtual
          </Typography>

          <Typography
            as="p"
            variant="paragraph1"
            style={{ textAlign: mobile ? "center" : "unset" }}
          >
            Productos y servicios visibles que impactarán a tu grupo objetivo,
            exhibidos en una tienda virtual atractiva y en sus dispositivos.
          </Typography>
        </Card>

        <Card
          style={{
            padding: mobile ? "30px 28px" : "30px 50px",
            alignItems: mobile ? "center" : "unset",
            backgroundColor: "hsl(0deg 0% 3%)",
          }}
        >
          <FeaturesIconContainer>
            <AnalyticsIcon height="56px" />
          </FeaturesIconContainer>

          <Typography
            as="h2"
            variant="title3"
            style={{
              color: theme.colorsPalette.white.default,
              textAlign: mobile ? "center" : "unset",
            }}
          >
            Analítica avanzada
          </Typography>

          <Typography
            as="p"
            variant="paragraph1"
            style={{ textAlign: mobile ? "center" : "unset" }}
          >
            Datos de todas las variables, para que en tiempo real te informes
            como va tu negocio y tomes decisiones efectivas.
          </Typography>
        </Card>

        <Card
          style={{
            padding: mobile ? "30px 28px" : "30px 50px",
            alignItems: mobile ? "center" : "unset",
            backgroundColor: "hsl(0deg 0% 3%)",
          }}
        >
          <FeaturesIconContainer>
            <EditIcon height="56px" />
          </FeaturesIconContainer>

          <Typography
            as="h2"
            variant="title3"
            style={{
              color: theme.colorsPalette.white.default,
              textAlign: mobile ? "center" : "unset",
            }}
          >
            Autogestionable
          </Typography>

          <Typography
            as="p"
            variant="paragraph1"
            style={{ textAlign: mobile ? "center" : "unset" }}
          >
            De manera simple podrás gestionar tus productos, tus clientes, tus
            ventas. Crea tú mismo la apariencia y contenido de tu tienda online:
            páginas. mensajes. colores. imágenes.
          </Typography>
        </Card>
      </FeaturesCardsContainer>
    </FeaturesSectionContainer>
  );
}
